import { render } from "./BiomarFooter.vue?vue&type=template&id=665b52a9&scoped=true"
const script = {}

import "./BiomarFooter.vue?vue&type=style&index=0&id=665b52a9&scoped=true&lang=scss"

import exportComponent from "/home/florian/dev/biomar/vue-starter-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-665b52a9"]])

export default __exports__